import { render, staticRenderFns } from "./ScreenVideo.vue?vue&type=template&id=d0505b40&"
import script from "./ScreenVideo.vue?vue&type=script&lang=js&"
export * from "./ScreenVideo.vue?vue&type=script&lang=js&"
import style0 from "./ScreenVideo.vue?vue&type=style&index=0&id=d0505b40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports